// videoContent Copyright 2022 Rebecca L Beaudet
import { LEARNING_PORTAL_NAME, EMAIL } from './constantContent';
import { writable } from 'svelte/store';
import { pdVideosListJson } from './pdVideosArray';
const pdVideos = writable(pdVideosListJson);
const videoReqLag = writable(true);
const pdVideoPitch = `We offer educational videos for parents, caregivers, and providers.
Each video has a copy of the slides and a professional development certificate on request.
Please contact ${EMAIL} with any issues purchasing or viewing the videos.
All payments are processed securely through Stripe.`;
const customerMsg = (customerName, email) => {
    return `Thank you ${customerName} for purchasing videos from ${LEARNING_PORTAL_NAME}!
 For continued access, your username is ${email}; your password was created automatically at checkout and stored in this web browser.
 In the future, we will support logins on other devices using these credentials. Until then, please watch on this device or save private YouTube links to a personal playlist.
 These private links are expected for personal use only. As they are easy to share this is on the honors system.
 We greatly appreciate the combined support of our audience, which contributes to our investment in providing future content.`;
};
export { pdVideos, pdVideoPitch, customerMsg, videoReqLag };
